import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';

const UnAuthorized = () => {
    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="text-center">
                    <h2>You are not authorized to access this page</h2>
                    <p>Please contact the administrator for assistance.</p>
                    <img src="https://sb-ui-kit-pro.startbootstrap.com/assets/img/illustrations/401-error-unauthorized.svg" style={{ width: '40%' }} />
                </div>
            </div>
        </div>
    );
};

export default UnAuthorized;
